import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue, setNewOptions } from "../../lib";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { MindMapDirectionMenuContent } from "./MindMapDirectionMenuContent";

interface MindMapDirectionMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function MindMapDirectionMenu({
    activeSubMenu,
    setActiveSubMenu,
}: MindMapDirectionMenuProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("mindMapDirection"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleDirectionButtonClick = useCallback(
        (direction: string) => {
            const setNewMindMapDirectionOptions = setNewOptions({
                name: "mindMapDirection",
                setWidgetMenuOptions,
            });

            function handleClose() {
                setActiveSubMenu(null);
            }

            applyValue({
                options,
                value: direction,
                setNewOptions: setNewMindMapDirectionOptions,
                handleClose,
            });
        },
        [options, setWidgetMenuOptions, setActiveSubMenu],
    );

    return (
        <SubMenu padding={8} activeSubMenu={activeSubMenu}>
            <MindMapDirectionMenuContent onDirectionButtonClick={handleDirectionButtonClick} />
        </SubMenu>
    );
}
